import { onboardingFactsSchema, onboardingPlanSchema } from "../start/onboarding-plan.js";
import * as z$1 from "zod/v4";
//#region src/schemas/agent-view/setup-plan.ts
const SETUP_PLAN_AGENT_VIEW_SCHEMA_VERSION = 1;
const SETUP_PLAN_AGENT_VIEW_CODE = "setup.plan";
const setupPlanAgentViewPayloadSchema = z$1.strictObject({
	schemaVersion: z$1.literal(1),
	readOnly: z$1.boolean(),
	facts: onboardingFactsSchema,
	plan: onboardingPlanSchema
});
const setupPlanAgentViewEventSchema = z$1.strictObject({
	type: z$1.literal("result"),
	code: z$1.literal(SETUP_PLAN_AGENT_VIEW_CODE),
	payload: setupPlanAgentViewPayloadSchema
});
//#endregion
export { SETUP_PLAN_AGENT_VIEW_CODE, SETUP_PLAN_AGENT_VIEW_SCHEMA_VERSION, setupPlanAgentViewEventSchema, setupPlanAgentViewPayloadSchema };

//# sourceMappingURL=setup-plan.js.map